import type { FC, ReactElement } from 'react';
import { MODAL_Z_INDEX } from '@constants/z-indices';
import { Dialog, DialogPanel } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import clsx from 'clsx';

interface AttachmentModalProps {
  children: ReactElement;
  handleClose: () => void;
}

export const AttachmentModal: FC<AttachmentModalProps> = ({ children, handleClose }) => (
  <Dialog
    open={true}
    as="div"
    className={clsx('fixed inset-0 overflow-y-auto', MODAL_Z_INDEX)}
    data-testid="section-modal"
    onClose={handleClose}
  >
    <div className="flex min-h-screen min-w-96 items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <div className="bg-info-500/75 fixed inset-0 transition-opacity" />

      <DialogPanel
        transition
        className="flex h-screen items-center justify-center duration-300 ease-out data-closed:transform-[scale(95%)] data-closed:opacity-0"
      >
        <div className="relative inline-block transform rounded-lg bg-white px-4 pt-5 pb-4 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle">
          <div className="absolute top-0 right-0 hidden pt-7 pr-4 sm:block">
            <button
              type="button"
              className="text-info-400 hover:text-info-500 rounded-md bg-white focus:ring-2 focus:ring-blue-500/50 focus:ring-offset-2 focus:outline-hidden"
              onClick={handleClose}
            >
              <span className="sr-only">Cancel</span>
              <XIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="sm:flex sm:items-start sm:justify-center">
            <div className="mt-3 w-full text-left sm:mt-0">{children}</div>
          </div>
        </div>
      </DialogPanel>
    </div>
  </Dialog>
);
